module.exports = __webpack_public_path__ + "img/icon_money.e59427f7.svg";